<form [formGroup]="ownerForm">
    <div class="form-container">
      <div class="form-row items-right ">
        <mat-radio-group  aria-label="Select owner’s address type">
          <mat-label> Select owner’s address type</mat-label>
        <mat-radio-button   (change)="radioChangeAddress($event)" [checked]="true" color="primary"  value="1">Domestic</mat-radio-button>
        <mat-radio-button    (change)="radioChangeAddress($event)" color="primary"  value="2">International</mat-radio-button>
      </mat-radio-group>
      </div>
      <div class="form-row">
        <div class="form-col">
          <mat-form-field  appearance="outline" requiered>
            <mat-label style="font-size: 16px !important;">Rental Property owner’s First name</mat-label>
            <input matInput formControlName="firstName"  placeholder="Rental Property owner’s First name"
            required> 
            <mat-error>Rental Property owner’s First name is required</mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="addressType == '1'"  class="form-col span-2">
          <mat-form-field class="mat-form-field-100" appearance="outline">
            <mat-label>Owners Street Address</mat-label>
            <input matInput class="form-outline form-control" placeholder="Owners Street Address" formControlName="ownerStreetAddress"  [matAutocomplete]="auto">
            <mat-autocomplete  #auto="matAutocomplete">
              <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description" (onSelectionChange)="selectPlaceOwner(suggestion)">
                {{ suggestion.description }}
              </mat-option>
            </mat-autocomplete>
            <mat-error>Owners Street Address is required</mat-error>
          </mat-form-field>
      </div> 
      <div *ngIf="addressType == '2'"   class="form-col span-2">
        <mat-form-field appearance="outline" >
            <mat-label>Address’s name</mat-label>
            <input class="form-outline form-control" formControlName="addressName"  matInput placeholder="Address’s name"
                   >
                
                   <mat-error>Address’s nameis required</mat-error>
          </mat-form-field>
    </div>
      </div>
      <div class="form-row">
        <div class="form-col">
        <mat-form-field  appearance="outline">
          <mat-label style="font-size: 16px !important;">Rental Property owner’s Last name</mat-label>
          <input matInput formControlName="lastName"   placeholder="Rental Property owner’s Last name"
          required> 
          <mat-error>Rental Property owner’s Last name is required</mat-error>
        </mat-form-field>
      </div>
      <div *ngIf="addressType == '1'"  class="form-col span-2">
        <mat-form-field appearance="outline" >
            <mat-label>Apt/Unit/Suite</mat-label>
            <input matInput formControlName="aptUnitSuite" placeholder="Apt/Unit/Suite"
                   >
               
          </mat-form-field>
    </div>
    <div *ngIf="addressType == '2'"   class="form-col span-2">
      <mat-form-field appearance="outline" >
          <mat-label>Street address or post office box number</mat-label>
          <input formControlName="addressOrPoBox" class="form-outline form-control" matInput placeholder="Street address or post office box number"
                 >
              
                 <mat-error>Street address or post office box numbe is required</mat-error>
        </mat-form-field>
  </div>
      </div>
      <div class="form-row">
        <div class="form-col">
        <mat-form-field  appearance="outline">
          <mat-label style="font-size: 16px !important;">Rental Property owner’s email address</mat-label>
          <input matInput formControlName="email"  placeholder="Rental Property owner’s email address"
          required>    <mat-error *ngIf="this.ownerForm.get('email')?.errors?.['email'] && (ownerForm.get('email')?.touched)">Rental Property owner's email address is invalid</mat-error>
           
          <mat-error  *ngIf="this.ownerForm.get('email')?.errors?.['required'] && (ownerForm.get('email')?.touched)">Rental Property owner's email address is required</mat-error>
        
        </mat-form-field>
        <div class="form-row">
          <div class="form-col">
            <mat-form-field  appearance="outline">
              <mat-label style="font-size: 16px !important;">Rental Property owner’s Phone Number</mat-label>
              <input matInput formControlName="phoneNumber"   placeholder="Rental Property owner’s Phone Number"
              required> 
              <mat-error *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['pattern'] && (ownerForm.get('phoneNumber')?.touched)">Rental Property owner's phone number is invalid</mat-error>
           
              <mat-error  *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['required'] && (ownerForm.get('phoneNumber')?.touched)">Rental Property owner's phone number is required</mat-error>
   
            </mat-form-field>
          </div>
        </div>
      </div>
      <div *ngIf="addressType == '1'" class="form-col  span-2">
        <div    class="form-row">
          <div class="form-col">
          <mat-form-field appearance="outline" >
            <mat-label>City</mat-label>
            <input matInput formControlName="city"  placeholder="City"
                   >
                   <mat-error>City is required</mat-error>
          </mat-form-field>
        
          </div>
          
          <div class="form-col">
          <mat-form-field appearance="outline" >
            <mat-label>State</mat-label>
          
                   <mat-select  formControlName="state"   placeholder="State">
                  
                    @for (state of states; track state) {
                      <mat-option [value]="state.id">{{state.name}}</mat-option>
                    }
                  </mat-select>
                  <mat-error>State is required</mat-error>
          </mat-form-field>
         
          </div>
          
          
          <div class="form-col">
          <mat-form-field appearance="outline" >
            <mat-label>Zip Code</mat-label>
            <input matInput formControlName="zipCode"  laceholder="Zip Code"
                   >
                   <mat-error *ngIf="this.ownerForm.get('zipCode')?.errors?.['pattern'] && (ownerForm.get('zipCode')?.touched)">Zip Code is invalid</mat-error>
           
                   <mat-error  *ngIf="this.ownerForm.get('zipCode')?.errors?.['required'] && (ownerForm.get('zipCode')?.touched)">Zip Code is required</mat-error>
       
          </mat-form-field>
       
          
          </div>
        </div>
      </div>
      <div *ngIf="addressType == '2'"   class="form-col  span-2">
        <mat-form-field appearance="outline" >
            <mat-label>City, State, Province</mat-label>
            <input class="form-outline form-control" formControlName="cityStateProvince"  matInput placeholder="City, State, Province"
                   >
                   <mat-error>City, State, Province is required</mat-error>
        
          </mat-form-field>
          <div class="form-row">
   
          <div *ngIf="addressType == '2'" class="form-col">
            <mat-form-field class="mat-form-field-100" appearance="outline" >
              <mat-label>Country</mat-label>
            
                     <mat-select formControlName="country"   placeholder="Country">
                    
                      @for (state of countries; track state) {
                        <mat-option [value]="state.id">{{state.name}}</mat-option>
                      }
                    </mat-select>
                    <mat-error>Country is required</mat-error>
            </mat-form-field>
          </div>
        </div>
    </div>
    </div>
    
    </div>
      
      </form>